import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { CompactFooterModule } from "@obg/ngx.ui.core";

import { BonusSelectionUiModule } from "../bonus-selection.module";

import { VisitorBonusContainer } from "./visitor-bonus.container";

const DIRECTIVES = [VisitorBonusContainer];

@NgModule({
	imports: [CommonModule, BonusSelectionUiModule, CompactFooterModule],
	exports: DIRECTIVES,
	declarations: DIRECTIVES,
})
export class VisitorBonusUiModule {}
